import { get } from '@/utils/request'

export const getProjectTypes = () => get('/project/meta/types')
export const getProjectStatuses = () => get('/project/meta/statuses')
export const getProjectStages = () => get('/project/meta/stages')
export const getRegionTree = () => get('/project/region/tree')
export const getMeetingResults = () => get('/project/meta/meeting-results')
